export default {
    props: {
        requiredFields: {
            type: Object,
            default: () => {
            },
        },
    },
    methods: {
        isRequired(inputName) {
            return this.requiredFields && this.requiredFields[inputName] !== undefined && this.requiredFields[inputName];
        },
        isRequiredDesignation(inputName) {
            return this.isRequired(inputName) ? '*' : '';
        },
    },
};
